import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ProgressStepDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    fill: {
        ...StyleSheet.absoluteFill
    },
    container: {
        overflow: "hidden",
        flex: 1
    }
});

export const useStyles = ({
    backgroundColor,
    shapeConfigs,
    fillColor,
    radiuses
}: ProgressStepDynamicStyleType) => {
    const styles = {
        container: {
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            }),
            backgroundColor
        } as Mutable<ViewStyle>,
        fill: {
            backgroundColor: fillColor
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
